// Идентификаторы сообщений TDLib: серверный id всегда кратен 2^20, младшие
// 20 бит — тип локального сообщения (1 — ещё не отправлено, 2 — локальное,
// созданное клиентом: сервисные плашки вроде таймера автоудаления и т.п.).
//
// Отвечать можно ТОЛЬКО на серверное сообщение. Если отдать TDLib reply_to с
// локальным id, он примет команду, положит отправку в binlog — и на каждом
// следующем старте убьёт процесс через LOG(FATAL) в MessageInputReplyTo.cpp
// («local message X in not a topic in chat Y»). Аккаунт становится миной:
// падает весь шард, а не одна сессия. См. инцидент 2026-09-11.
const SERVER_ID_SHIFT = 1n << 20n;
export const isServerMessageId = (messageId) => {
    let id;
    try {
        id = BigInt(messageId);
    }
    catch {
        return false;
    }
    return id > 0n && id % SERVER_ID_SHIFT === 0n;
};
//# sourceMappingURL=message-id.js.map